const getRandom = (items) => items[Math.floor(Math.random() * items.length)];

const winVariants = (score, minutes, seconds, incorrectGuesses, streakLine) => [
  `${streakLine}I solved today's Newsie with a score of ${score}\nin: ${minutes}:${seconds} with ${incorrectGuesses} incorrect guesses.`,
  `${streakLine}Newsie: solved in ${minutes}:${seconds} with ${incorrectGuesses} wrong guesses. Score: ${score}.`,
];

const lossVariants = (incorrectGuesses, streakLine) => [
  `${streakLine}Newsie stumped me today after ${incorrectGuesses} guesses 😅 Think you can do better?`,
  `${streakLine}Today's Newsie got the better of me (${incorrectGuesses} wrong guesses). Can you crack it?`,
];

export const buildShareText = ({ won, score, time, incorrectGuesses, streak }) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60 < 10 ? `0${time % 60}` : time % 60;
  const streakLine = streak > 1 ? `🔥 ${streak}-day streak! ` : '';
  const title = 'Newsie: News Puzzle';
  const variants = won
    ? winVariants(score, minutes, seconds, incorrectGuesses, streakLine)
    : lossVariants(incorrectGuesses, streakLine);
  const text = `${getRandom(variants)}\n\nCan you beat my score?`;
  return { title, text };
};
